export const isRunningInCypressRun = () => {
  return Boolean("Cypress" in window && window.Cypress);
};
